import React, { useState } from 'react';
import { Play } from 'lucide-react';

/**
 * Card with image as poster + YouTube video on hover (desktop) or tap (mobile).
 * The iframe is mounted only on hover to save bandwidth.
 *
 * Props:
 *  - image  (string)  : poster image URL
 *  - youtubeId (string) : YouTube video ID, plays muted/looped on hover
 *  - alt (string)
 *  - className (string)
 */
const HoverVideoCard = ({ image, youtubeId, alt, className = '' }) => {
  const [active, setActive] = useState(false);

  const onEnter = () => { if (youtubeId) setActive(true); };
  const onLeave = () => { setActive(false); };
  const onTap = () => {
    if (!youtubeId) return;
    setActive((v) => !v);
  };

  const src = youtubeId
    ? `https://www.youtube.com/embed/${youtubeId}?autoplay=1&mute=1&loop=1&controls=0&showinfo=0&rel=0&modestbranding=1&playsinline=1&playlist=${youtubeId}`
    : null;

  return (
    <div
      className={`relative w-full h-full overflow-hidden bg-black ${className}`}
      onMouseEnter={onEnter}
      onMouseLeave={onLeave}
      onClick={onTap}
    >
      <img
        src={image}
        alt={alt}
        className={`w-full h-full object-cover transition-transform duration-700 ${active ? 'opacity-0' : 'opacity-100 group-hover:scale-105'}`}
        loading="lazy"
      />
      {active && src && (
        <div className="absolute inset-0 pointer-events-none">
          <iframe
            title={alt}
            src={src}
            className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[177.78vh] h-[56.25vw] min-w-full min-h-full"
            style={{ aspectRatio: '16 / 9' }}
            frameBorder="0"
            allow="autoplay; encrypted-media; picture-in-picture"
            allowFullScreen
          />
        </div>
      )}
      {youtubeId && (
        <div className={`absolute top-3 right-3 flex items-center gap-1.5 px-2.5 py-1 rounded-full bg-black/60 backdrop-blur-sm text-white text-[10px] tracking-[0.2em] uppercase pointer-events-none transition-opacity ${active ? 'opacity-0' : 'opacity-90'}`}>
          <Play className="w-3 h-3 fill-white" /> Vidéo
        </div>
      )}
    </div>
  );
};

export default HoverVideoCard;
